module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/esia-cea48780acc3c71690ac71f8a6c7379e.png";